"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lighten = exports.darken = exports.buttonAccentColors = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var hexToRgb = function hexToRgb(hex) {
  var value = hex.replace('#', '');
  return [parseInt(value.substring(0, 2), 16), parseInt(value.substring(2, 4), 16), parseInt(value.substring(4, 6), 16)];
};
var rgbToHex = function rgbToHex(r, g, b) {
  return '#' + [r, g, b].map(function (channel) {
    return Math.max(0, Math.min(255, Math.round(channel))).toString(16).padStart(2, '0');
  }).join('');
};
var mix = function mix(hex, target, weight) {
  var _hexToRgb = hexToRgb(hex),
    _hexToRgb2 = _slicedToArray(_hexToRgb, 3),
    r1 = _hexToRgb2[0],
    g1 = _hexToRgb2[1],
    b1 = _hexToRgb2[2];
  var _hexToRgb3 = hexToRgb(target),
    _hexToRgb4 = _slicedToArray(_hexToRgb3, 3),
    r2 = _hexToRgb4[0],
    g2 = _hexToRgb4[1],
    b2 = _hexToRgb4[2];
  return rgbToHex(r1 + (r2 - r1) * weight, g1 + (g2 - g1) * weight, b1 + (b2 - b1) * weight);
};
var lighten = function lighten(hex, amount) {
  return mix(hex, '#ffffff', amount);
};
exports.lighten = lighten;
var darken = function darken(hex, amount) {
  return mix(hex, '#000000', amount);
};

// Derived, theme-relative shades for button hover/active/loading states, so buttons stay
// in sync with whatever `colors.primary` a given service sets, instead of hardcoded hex.
exports.darken = darken;
var buttonAccentColors = function buttonAccentColors(colors) {
  return {
    accentBorder: lighten(colors.primary, 0.35),
    mutedText: lighten(colors.primary, 0.45),
    hoverBgLight: darken(colors.secondary, 0.02),
    primaryHoverBg: darken(colors.primary, 0.15),
    secondaryHoverBg: darken(colors.lightPrimary, 0.04),
    loadingTextPrimary: lighten(colors.primary, 0.4),
    loadingTextSecondary: lighten(colors.primary, 0.3)
  };
};
exports.buttonAccentColors = buttonAccentColors;